import { createContext } from 'react';

export interface PopoverContextValue {
  checkActive: (id: string, groupId: string) => boolean;
  setActive: (id: string, groupId: string) => void;
}

export const PopoverManagerContext = createContext<PopoverContextValue>({
  checkActive: () => true,
  setActive: () => {}
});
